import { render } from "./MakeWish.vue?vue&type=template&id=0c54498c&scoped=true"
import script from "./MakeWish.vue?vue&type=script&lang=js"
export * from "./MakeWish.vue?vue&type=script&lang=js"

import "./MakeWish.vue?vue&type=style&index=0&id=0c54498c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c54498c"]])

export default __exports__